import { useEffect, useState } from 'react'
import NormalFeed from '@/components/NormalFeed'
import { unwrappedFeedAtom } from '@/atoms/feed'
import { TFeedSubRequest } from '@/types'
import { useAtomValue } from 'jotai'

export default function HardcodedFeed() {
  const feed = useAtomValue(unwrappedFeedAtom)
  const [subRequests, setSubRequests] = useState<TFeedSubRequest[]>([])

  useEffect(() => {
    if (!feed || !('hardcodedFeed' in feed)) {
      setSubRequests([])
      return
    }

    const item = window.hallway.universe.hardcodedFeeds[feed.hardcodedFeed]
    if (!item) {
      setSubRequests([])
      return
    }
    const requests: TFeedSubRequest[] = []

    if (item.relays?.length) {
      requests.push({
        source: 'relays',
        urls: item.relays,
        filter: {
          kinds: window.hallway.universe.feedKinds
        }
      })
    }

    if (item.pubkeys?.length) {
      // local source: queries the local store and listens for live updates.
      // subscribeTimeline will fall back to outbox relays if the local store has nothing.
      requests.push({
        source: 'local',
        filter: {
          authors: item.pubkeys
        }
      })
    }

    setSubRequests(requests)
  }, [feed])

  return <NormalFeed subRequests={subRequests} />
}
